// Splits Slack mrkdwn text into the block-level runs MrkdwnText draws: a bulleted
// list, a quote, or a paragraph. Everything that is not a bulleted or quoted line
// stays one paragraph.
export type MrkdwnBlock =
  | { kind: 'paragraph'; text: string }
  | { kind: 'list'; items: string[] }
  | { kind: 'quote'; text: string };

type LineKind = 'bullet' | 'quote' | 'plain';

function lineKind(line: string): LineKind {
  if (line.startsWith('• ') || line.startsWith('- ')) return 'bullet';
  if (line.startsWith('> ')) return 'quote';
  return 'plain';
}

export function mrkdwnBlocks(text: string): MrkdwnBlock[] {
  const lines = text.split('\n');
  const blocks: MrkdwnBlock[] = [];
  let index = 0;

  while (index < lines.length) {
    const kind = lineKind(lines[index]);
    const run: string[] = [];
    while (index < lines.length && lineKind(lines[index]) === kind) {
      run.push(lines[index]);
      index++;
    }

    if (kind === 'bullet') {
      blocks.push({ kind: 'list', items: run.map((line) => line.slice(2)) });
    } else if (kind === 'quote') {
      blocks.push({
        kind: 'quote',
        text: run.map((line) => line.slice(2)).join('\n'),
      });
    } else {
      blocks.push({ kind: 'paragraph', text: run.join('\n') });
    }
  }

  return blocks;
}
